import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'
import { Offcanvas, Tab, Tabs } from 'react-bootstrap'
import { PanelFooter, PanelHeader } from 'components/Panel'
import RichTextPreview from 'components/RichText/RichTextPreview'

function VerWiki(props) {
	const { wiki, setQueMostrar } = props
	const labelsDeEtiquetas = wiki.etiquetas.length > 0 ? wiki.etiquetas.map(elem => elem.nombre).join(', ') : '-'

	const handleClose = () => {
		setQueMostrar('')
	}

	// render
	return (
		<Offcanvas show={true} onHide={handleClose} placement="end" scroll="true" responsive="lg">
			<PanelHeader onClick={handleClose} iconClass="fa-arrow-left" btnText="Atrás" text="Ver entrada" />
			<Offcanvas.Body id="ver-wiki">
				<Row>
					<Col xs={12} md={4}>
						{wiki.imagen ? (
							<img
								src={process.env.REACT_APP_API_URL + wiki.imagen.url}
								alt=""
								className="img-fluid"
								style={{ backgroundColor: '#ccc', width: '100%', aspectRatio: '1/1', objectFit: 'cover' }}
							/>
						) : (
							<div
								className="d-flex justify-content-center align-items-center"
								style={{ backgroundColor: '#ccc', width: '100%', aspectRatio: '1/1' }}
							>
								<span className="text-white" style={{ fontSize: '2rem' }}>FOTO</span>
							</div>
						)}
					</Col>
					<Col xs={12} md={8}>
						<h2>Nombre</h2>
						<p>{wiki.nombre}</p>

						<label>Etiquetas</label>
						<div className="etiquetas">
							{labelsDeEtiquetas}
						</div>

						<h2>DESCRIPCIÓN</h2>
						<p>{wiki.descripcion}</p>
					</Col>
				</Row>

				<Row className="mt-4">
					<Col>
						<Tabs defaultActiveKey="usos" className="mb-3">
							<Tab eventKey="usos" title="Usos y características">
								<RichTextPreview rawContent={wiki.usos ? JSON.parse(wiki.usos) : ''} />
							</Tab>
							<Tab eventKey="cultivo" title="Cultivo y procesamiento">
								<RichTextPreview rawContent={wiki.cultivo ? JSON.parse(wiki.cultivo) : ''} />
							</Tab>
							<Tab eventKey="experiencias" title="Experiencias">
								<RichTextPreview rawContent={wiki.experiencias ? JSON.parse(wiki.experiencias) : ''} />
							</Tab>
						</Tabs>
					</Col>
				</Row>
			</Offcanvas.Body>
			<PanelFooter>
				<Button variant="outline-primary" onClick={handleClose} className="me-2">
					Ok
				</Button>
			</PanelFooter>
		</Offcanvas>
	)
}

export default VerWiki